import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as userStorageService from 'services/user-storage-service';

import Tooltip from 'components/tooltip';

import IconArrowLeft from 'icons/icon-arrow-left'

const COLLAPSED_STATE_KEY = 'gantt_chart_collapsed';

const GanttChartSide = ({ id, head, foot, children }) => {
    const [collapsed, setCollapsed] = useState(id ? userStorageService.get(`${COLLAPSED_STATE_KEY}_${id}`) : false);
    const { t } = useTranslation('common');

    const handleCollapseToggle = () => {
        if (id) {
            userStorageService.set(`${COLLAPSED_STATE_KEY}_${id}`, !collapsed)
        }

        setCollapsed(prevState => !prevState);
    }

    return (
        <div className={'gantt-chart-side' + (collapsed ? ' collapsed' : '')}>
            <div className="gantt-chart-side-inner">
                {
                    head && !collapsed ? (
                        <div className="gantt-chart-side-head">
                            <div className="gantt-chart-side-head-inner">
                                { head }
                            </div>
                        </div>
                    ) : null
                }

                <Tooltip tooltip={collapsed ? t('Expand') : t('Collapse')}>
                    <button className="btn collapse-toggle" onClick={handleCollapseToggle}><IconArrowLeft /></button>
                </Tooltip>

                { !collapsed && children }

                {
                    foot ? (
                        <div className="gantt-chart-side-foot">
                            { foot }
                        </div>
                    ) : null
                }
            </div>
        </div>
    )
}

export default GanttChartSide;
